import { getBaseUrl } from '../utils/apiHelper';

const API_URL = `${getBaseUrl()}/api/auth`;

const verificationService = {
  sendVerificationCode: async (email) => {
    const res = await fetch(`${API_URL}/send-verification-code`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || 'Failed to send verification code');
    return data;
  }
};

export default verificationService;
